import { createContext, useEffect, useState, ReactNode } from "react";
import { useKeycloakContext } from "../../keycloak";
import io, { Socket } from "socket.io-client";

interface SocketProviderProps {
  children: ReactNode;
}

export const SocketContext = createContext<Socket | null>(null);

export const SocketProvider = ({ children }: SocketProviderProps) => {
  const [socket, setSocket] = useState<Socket | null>(null);

  const keycloakContext = useKeycloakContext();

  const token = keycloakContext?.keycloak?.token;

  useEffect(() => {
    if (!token) return;

    const newSocket = io(process.env.REACT_APP_DSC_SERVICE_CHAT!, {
      extraHeaders: {
        authorization: token,
      },
    });
    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, [token]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export default SocketContext;
